import useTranslation from 'hooks/useTranslation'
import Warehouse from 'components/Warehouse'
import React from 'react'

interface WarehouseProps {
  warning?: boolean
  showShadow?: boolean
  inFuture: boolean
  dateFrom: string
  doorState: warehouse.ObjectStateWarehouse
}

const WarehouseComponent: React.FC<WarehouseProps> = ({ warning, showShadow, inFuture, dateFrom, doorState }) => {
  const { t } = useTranslation('warehouse')
  return (
    <Warehouse
      warning={warning}
      showShadow={showShadow}
      lock={doorState?.lock}
      door={doorState?.door}
      alert={inFuture
        ? {
          title: t('comingSoon'),
          desc: `${t('youWillBeAbleToComeIn')}: ${dateFrom}`
        }
        : undefined
      }
    />
  )
}

export default WarehouseComponent